import React from "react";

import releases from "./releases";

import "./product-release.css";

class ProductReleasePage extends React.Component {
	render() {
		const { version } = this.props.match.params;
		const ReleaseContent = releases[version];

		if (!ReleaseContent) {
			return (
				<div className="product-release product-release--not-found">
					<div className="product-release__container">
						<span className="product-release__not-found-title">Release not found</span>
						<span className="product-release__not-found-subtitle">We couldn't find a release page for "{version}".</span>
					</div>
				</div>
			);
		}

		return (
			<div className="product-release">
				<div className="product-release__container">
					<ReleaseContent />
				</div>
			</div>
		);
	}
}

export default ProductReleasePage;
